









































import { OpportunityActions, Opportunity } from '@/models/opportunities';
import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'GiveFeedbackOpportunityModal',
  props: {
    opportunity: Object as () => Opportunity,
  },
  data() {
    return {
      feedback: '',
      loader: {
        isRequestPending: false,
      },
    };
  },
  methods: {
    async sendFeedback() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.giveFeedback,
          { opportunityId: this.opportunity.id, message: this.feedback },
        );
        this.$bvModal.hide('give-feedback-opportunity-modal');
        ToastsService.success(this.$t('opportunities.details.notifications.give-feedback') as string);
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    resetModal() {
      this.feedback = '';
    },
  },
});
